import React from 'react';
import { useFormContext } from '../../components/FormContext';


const WorkDatesSection = () => {
  const { 
    formData, 
    formErrors, 
    modifiedFields,
    setFieldValue,
    setFormErrors, 
    setModifiedFields
  } = useFormContext();


    const validatePastDate = (field, e) => {
    const value = e.target.value;
    setFieldValue('dateOfBirth', value);
    setModifiedFields(prev => new Set([...prev, field]));

    let error = null;
    if (!value) {
      error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } else {
        
      const selectedDate = new Date(value);
      const today = new Date();
        
    if (selectedDate > today) {
        error = `${field.charAt(0).toUpperCase() + field.slice(1)} cannot be in the future`; 
      }
        
      
    }

    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
  };


  const validateDateChange = (field, e) => {
    const value = e.target.value;
    setFieldValue('startWork', value);
    setModifiedFields(prev => new Set([...prev, field]));

    let error = null;
    if (!value) {
      error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
    } 
        
      
    

    if (error) {
      setFormErrors(prev => ({...prev, [field]: error}));
    } else {
      setFormErrors(prev => {
        const newErrors = {...prev};
        delete newErrors[field];
        return newErrors;
      });
    }
  };


  return (
    <div className="form-section">
      <h4 className="text-lg font-medium text-gray-700 mb-3">Dates Information</h4>
      <div className="space-y-4">
        <div>
          <label htmlFor="start-work" className="block text-sm font-medium text-gray-700 mb-1">
              Start Work Date
            </label>
          <input
            type="date"
            id="start-work"
            name="startWork"
            value={formData.startWork}
            onChange={(e) => validateDateChange('startWork', e)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              />
                  
              {formErrors.startWork && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('startWork') && (
            <div className="text-sm text-red-600 mt-1">
                {formErrors.startWork}
              </div>
              )}
            </div>
                
            <div>
              <label htmlFor="date-of-birth" className="block text-sm font-medium text-gray-700 mb-1">
                  Date of Birth
              </label>
              <input
                type="date"
                id="date-of-birth"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={(e) => validatePastDate('dateOfBirth', e)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                />
                  
              {formErrors.dateOfBirth && modifiedFields && 
          typeof modifiedFields.has === 'function' && modifiedFields.has('dateOfBirth') && (
              <div className="text-sm text-red-600 mt-1">
                  {formErrors.dateOfBirth}
              </div>
              )}
            </div>
        </div>
    </div>
    );
};

export default WorkDatesSection;